import { Injectable } from '@angular/core';
import { FormActionHandlerService } from './base.service';
import { DownloadService } from '../../../fastlane-common/services/download.service';
import { FormShareService } from '../share.service';
import { FormIdentifier } from '../../../project/models/form-identifier.model';

@Injectable()
export class PreviewRdApprovalLetterActionHandlerService extends FormActionHandlerService {
  constructor(
    private downloadService: DownloadService,
    private shareService: FormShareService
  ) {
    super();
  }

  exec(): Promise<any> {
    return new Promise((resolve, reject) => {
      this.downloadService
        .openFormSnapshot(
          this.shareService.formId,
          this.shareService.project.projectInfo.projectId,
          null,
          "xUU123abc-RD"
        )
        .subscribe(resolve, error => reject(error));
    });
  }
}
